// extracted by mini-css-extract-plugin
var _1 = "fill__jNyjh";
var _2 = "full-viewport__qGcMG";
export { _1 as "fill", _2 as "fullViewport" }
